// HomeButton component - provides consistent "back to home" functionality
// Positioned same as menu close button (top: 20px, left: 20px)

function HomeButton({ onNavigate }) {
  return (
    <button
      onClick={() => onNavigate('home')}
      style={{
        position: 'absolute',
        top: '20px',
        left: '20px',
        background: '#5B8FA8',
        color: 'white',
        border: 'none',
        width: '44px',
        height: '44px',
        borderRadius: '12px',
        fontSize: '18px',
        fontWeight: 'bold',
        cursor: 'pointer',
        zIndex: '10000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(45, 90, 110, 0.35)',
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'translateY(-2px)'
        e.target.style.boxShadow = '0 6px 16px rgba(45, 90, 110, 0.45)'
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translateY(0)'
        e.target.style.boxShadow = '0 4px 12px rgba(45, 90, 110, 0.35)'
      }}
      title="Back to Home"
    >
      ←
    </button>
  )
}

export default HomeButton